import { render } from "./ProfilesComponent.vue?vue&type=template&id=7f3cb5f8"
import script from "./ProfilesComponent.vue?vue&type=script&lang=js"
export * from "./ProfilesComponent.vue?vue&type=script&lang=js"

import "./ProfilesComponent.vue?vue&type=style&index=0&id=7f3cb5f8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__